<template>
  <div>
    <sidebar-item
      :link="{
            name: $t('sidebar.dashboard'),
            icon: 'tim-icons icon-chart-pie-36',
            path: {name: 'four_pl.dashboard'},
          }"
    />

    <sidebar-item
      :link="{
        name: $t('sidebar.control_tower'),
        icon: 'tim-icons icon-chart-bar-32',
      }"
    >
      <sidebar-item
        :link="{
          name: $t('sidebar.kanban'),
          path: {name: 'four_pl.control_tower'},
          isRoute: false,
        }" />

      <sidebar-item
        :link="{
          name:  $t('sidebar.map'),
          path: {name: 'four_pl.order_in_progress'}
        }" />
    </sidebar-item>

    <sidebar-item
      :link="{
            name: $t('sidebar.requests'),
            icon: 'tim-icons icon-basket-simple',
          }"
    >
      <sidebar-item
        v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value])"
        :material=true
        :link="{
          name: $t('sidebar.request'),
          icon: 'playlist_add_check',
          path: {name: 'four_pl.request'},
          isRoute: false,
        }"
      />
      <sidebar-item
        v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value])"
        :material=true
        :link="{
          name: $t('sidebar.road_map'),
          icon: 'map',
          path: {name: 'four_pl.road_map'},
          isRoute: false,
        }"
      />
    </sidebar-item>
    <sidebar-item
      v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value]) && $hasPlanOrBetter(plans.LOGISTIC_MANAGER.ADVANCED.value)"
      :link="{
            name: $t('sidebar.shippings'),
            icon: 'tim-icons icon-coins',
          }"
    >
      <sidebar-item
        v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value]) && $hasPlanOrBetter(plans.LOGISTIC_MANAGER.PREMIUM.value)"
        :link="{
          name: $t('sidebar.simulation'),
          path: {name: 'four_pl.order_simulation'},
          isRoute: false,
      }"/>
      <sidebar-item
        :link="{
          name: this.$t('sidebar.quotes'),
          path: {name: 'four_pl.order_quotes'},
          isRoute: false,
        }" />

      <sidebar-item
        v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value]) && $hasPlanOrBetter(plans.LOGISTIC_MANAGER.PREMIUM.value)"
        :link="{
          name: $t('sidebar.approve_table'),
          path: {name: 'four_pl.simulation.approve_table'},
          isRoute: false,
      }"/>

      <sidebar-item
        v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value]) && $hasPlanOrBetter(plans.LOGISTIC_MANAGER.PREMIUM.value)"
        :link="{
          name: $t('sidebar.approve_route_table'),
          path: {name: 'four_pl.approve_route_table'},
          isRoute: false,
      }"/>
    </sidebar-item>
    <sidebar-item
      v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value])"
      :link="{
            name: $t('pages.order.title.order'),
            icon: 'tim-icons icon-delivery-fast',
          }"
    >
      <sidebar-item
        v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value])"
        :link="{
            name: $t('sidebar.all_orders'),
            path: {name: 'four_pl.order'}
          }" />
      <sidebar-item
        v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value])"
        :link="{
            name: $t('sidebar.canceled'),
            path: {name: 'four_pl.order_canceled'}
      }"/>
      <sidebar-item
        :material="true"
        :link="{
          name: $t('sidebar.address'),
          icon: 'list',
          path: {name: 'four_pl.address_alias'}
        }"
      />

    </sidebar-item>
    <sidebar-item
      v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value]) && $hasPlanOrBetter(plans.LOGISTIC_MANAGER.ADVANCED.value)"
      :link="{
            name: $t('sidebar.purchase_order'),
            icon: 'tim-icons icon-cart',
          }">
      <sidebar-item
        :link="{
            name: $t('sidebar.charts'),
            path: {name: 'four_pl.purchase_order_board'}
          }">
      </sidebar-item>
      <sidebar-item
        v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value])"
        :link="{
            name: $t('sidebar.add'),
            icon: 'tim-icons icon-cart',
            path: {name: 'four_pl.purchase_order_create'}

          }">
      </sidebar-item>
      <sidebar-item
        v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value])"
        :link="{
            name: $t('sidebar.purchase_order'),
            icon: 'tim-icons icon-cart',
            path: {name: 'four_pl.purchase_order'}

          }">
      </sidebar-item>
      <sidebar-item
        v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value])"
        :link="{
            name: $t('sidebar.import'),
            icon: 'tim-icons icon-cloud-upload-94',
            path: {name: 'four_pl.imports'}
          }">
      </sidebar-item>
      <sidebar-item
        v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value])"
        :link="{
            name: $t('sidebar.exports'),
            icon: 'tim-icons icon-notes',
            path: {name: 'four_pl.purchase_order_exports'}
          }">
      </sidebar-item>
    </sidebar-item>
    <sidebar-item
      v-if="$canAny([
          permission.INTEGRA_MANAGER__OWNER.value,
          permission.INTEGRA_MANAGER__ADMIN.value,
          permission.INTEGRA_MANAGER__FINANCIER.value,
          permission.INTEGRA_MANAGER__FINANCIER_BASIC.value
        ])"
      :material="true"
      :link="{
            name: $t('sidebar.reports'),
            icon: 'list',
          }"
    >
      <sidebar-item
        v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value]) && $hasPlanOrBetter(plans.LOGISTIC_MANAGER.ADVANCED.value)"
        :link="{
          name: $t('sidebar.list_documents'),
          path: {name: 'four_pl.orders_documents'},
          isRoute: false,
        }"/>
      <sidebar-item
      v-if="$canAny([
        permission.INTEGRA_MANAGER__OWNER.value,
        permission.INTEGRA_MANAGER__ADMIN.value
      ]) && $hasPlanOrBetter(plans.LOGISTIC_MANAGER.BASIC.value)"
      :link="{
          name: $t('sidebar.orders'),
          icon: 'tim-icons icon-notes',
          path:{name: 'four_pl.order_export'},
        }"
      />
      <sidebar-item
        v-if="$canAny([
          permission.INTEGRA_MANAGER__OWNER.value,
          permission.INTEGRA_MANAGER__ADMIN.value,
          permission.INTEGRA_MANAGER__FINANCIER.value,
          permission.INTEGRA_MANAGER__FINANCIER_BASIC.value
        ]) && $hasPlanOrBetter(plans.LOGISTIC_MANAGER.PRO.value)"
        :material="true"
        :link="{
          name: $t('sidebar.canhoto_check'),
          icon: 'assignment_turned_in',
          path: {name: 'four_pl.canhoto'}
        }"
      />
      <sidebar-item
        v-if="$canAny([
          permission.INTEGRA_MANAGER__OWNER.value,
          permission.INTEGRA_MANAGER__ADMIN.value
        ]) && $hasPlanOrBetter(plans.LOGISTIC_MANAGER.PRO.value)"
        :material="true"
        :link="{
          name: 'CTes',
          icon: 'list',
          path: {name: 'four_pl.list_cte'}
        }"
      />
      <sidebar-item
        v-if="$hasPlanOrBetter(plans.LOGISTIC_MANAGER.PRO.value)"
        :link="{
          name: $t('sidebar.nf_files'),
          icon: 'assignment_turned_in',
          path: {name: 'four_pl.nf_files'}
        }"
      />
    </sidebar-item>
    <sidebar-item
      v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value])"
      :link="{
            name: $t('sidebar.exports_imports'),
            icon: 'tim-icons icon-notes',
          }"
    >
      <sidebar-item
        v-if="$hasPlanOrBetter(plans.LOGISTIC_MANAGER.ADVANCED.value)"
        :link="{
          name: $t('sidebar.list_documents'),
          icon: 'tim-icons icon-notes',
          path:{name: 'four_pl.orders_documents_export'},
        }"
      />

      <sidebar-item
        v-if="$hasPlanOrBetter(plans.LOGISTIC_MANAGER.BASIC.value)"
        :link="{
          name: $t('sidebar.orders'),
          icon: 'tim-icons icon-notes',
          path:{name: 'four_pl.order_reports'},
        }"
      />
      <sidebar-item
      v-if="$canAny([
        permission.INTEGRA_MANAGER__OWNER.value,
        permission.INTEGRA_MANAGER__ADMIN.value
      ])"
      :link="{
          name: $t('sidebar.transporters'),
          icon: 'tim-icons icon-notes',
          path:{name: 'four_pl.transporters_export'},
        }"
      />

      <sidebar-item
        v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value]) && $hasPlanOrBetter(plans.LOGISTIC_MANAGER.PRO.value)"
        :link="{
          name: $t('sidebar.import_cte'),
          path: {name: 'four_pl.import_cte'},

      }"/>

    </sidebar-item>
    <sidebar-item
      v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value])"
      :material=true
      :link="{
            name: $t('sidebar.users_and_companies'),
            icon: 'group',
            isRoute: false,
          }"
    >
      <sidebar-item
        v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value])"
        :material=true
        :link="{
              name: $t('sidebar.users'),
              icon: 'group',
              path: {name: 'four_pl.user'},
              isRoute: false,
            }"
      />
      <sidebar-item
        v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value])"
        :link="{
              name: $t('sidebar.transporters'),
              icon: 'tim-icons icon-bus-front-12',
              path: {name: 'four_pl.transporters'},
            }"
      />
      <sidebar-item
        v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value])"
        :link="{
              name: $t('sidebar.drivers'),
              icon: 'tim-icons icon-single-02',
              path: {name: 'four_pl.driver'}
            }"
      />
      <sidebar-item
        v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value])"
        :material=true
        :link="{
              name: $t('sidebar.shippers_customers'),
              icon: 'people_alt',
              path: {name: 'four_pl.customer'}
            }"
      />
    </sidebar-item>
  </div>
</template>

<script>
  import userPermission from "@/util/valueObjects/userPermission";
  import userRole from "@/util/valueObjects/userRole";
  import plans from "@/util/valueObjects/plans";

  export default {
    name: "sidebar",
    data(){
      return{
        role: userRole,
        permission: userPermission,
        plans: plans
      }
    }
  }
</script>

<style scoped>

</style>
